import { TApplication } from '@api/types'
import { store } from '@stores'
import { extractMaxLimit, extractMinLimit } from '@utils'

import { TShopInfo } from '../../api/types/payment/TShopInfo'
import { TSellSenderInfoResponse } from '../../api/types/sell/TSellSenderInfoResponse'
import { TBank } from '../../api/types/TBank'
import { TPaymentReceiverInfoResponse } from '../../api/types/TPaymentReceiverInfoResponse'
import { TPersonalData } from '../../api/types/TPersonalData'
import { TPaymentGateway } from '../../stores/types/TPaymentGatewayState'

export const payFormService = {
  initPayForm(application: TApplication) {
    store.dispatch.payForm.init({ application })
  },
  initFormGw(gw: TPaymentGateway) {
    store.dispatch.payForm.set({
      rate: gw.exchangeRate,
    })
    store.dispatch.payForm.set({
      minLimit: extractMinLimit(gw),
      maxLimit: extractMaxLimit(gw),
    })
  },
  initShopInfo(shop: TShopInfo) {
    store.dispatch.payForm.set({
      fee: +shop.commission,
      shopName: shop.shopName,
    })
  },
  initBySession(gws: TPaymentGateway[]) {
    store.dispatch.payForm.initBySession(gws)
  },
}

export const personalDataService = {
  init(data: TPersonalData) {
    store.dispatch.payForm.initPersonalData(data)
  },
}

export const p2pPurchaseService = {
  initP2PReceiverInfo(paymentReceiver: TPaymentReceiverInfoResponse) {
    store.dispatch.p2pPurchase.initP2PReceiverInfo(paymentReceiver)
  },
}

export const p2pSellService = {
  initP2PSenderInfo(sellSender: TSellSenderInfoResponse) {
    store.dispatch.p2pSell.initP2PSenderInfo(sellSender)
  },
}

export const banksService = {
  init(banks: TBank[]) {
    store.dispatch.banks.init({ banks: banks })
  },
}
